import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { SelectedDepartmentFilter } from 'support/filters'
import { StaticFilter } from '@morningtrain/react-filters'
import { Percentage } from 'support/displays'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import CookieFilter from "support/filters/CookieFilter";

export default function TrendingProductsTable ({
  limit = 5,
  product = '',
  striped = true,
  operationContext = {}
}) {
  return (
    <Widget>
      <Translator namespace='economy.trending_products'>
        <Collection resourceName='economy' operationName='trending_products' operationContext={{ category: product, ...operationContext }}>
          <CookieFilter name='period' cookieKey='page.filters.period' />
          <StaticFilter name='category' value={product} />
          <StaticFilter name='limit' value={limit} />
          <SelectedDepartmentFilter />

          <div className='flex mt-2 flex-grow'>
            <div className='w-full flex-grow'>
              <Translator namespace='economy.trending_products.columns'>
                <Table striped={striped}>
                  <Columns.Column name='name' label={<Translation name='name' />}>
                    <UI.Text truncate className='w-40'>
                      <Displays.Text name='name' />
                    </UI.Text>
                  </Columns.Column>
                  <Columns.Percentage alignment='right' name='share' decimals={1} className='w-1/4' label={<Translation name='share' />} />
                </Table>
              </Translator>
            </div>
          </div>

        </Collection>
      </Translator>
    </Widget>
  )
}
